import moment from 'moment';

export const loadTimeForm = form =>
  form.startDatetimeIsOnlyDate ? null : moment(form.startDatetime);
